export default __webpack_public_path__ + "static/small-business-accomplishment-2g-30a0277f19cd79003d61093b189eb763.webp";